__turbopack_context__.v({
  "ActionRequired": "_71VIVG_ActionRequired",
  "BasePrice": "_71VIVG_BasePrice",
  "DecrementButton": "_71VIVG_DecrementButton",
  "Disabled": "_71VIVG_Disabled",
  "DiscountedPrice": "_71VIVG_DiscountedPrice",
  "Image": "_71VIVG_Image",
  "ImageContainer": "_71VIVG_ImageContainer",
  "IncrementButton": "_71VIVG_IncrementButton",
  "NoteContainer": "_71VIVG_NoteContainer",
  "NoteTooltip": "_71VIVG_NoteTooltip",
  "NoteTooltipArrow": "_71VIVG_NoteTooltipArrow",
  "NoteTooltipClose": "_71VIVG_NoteTooltipClose",
  "NoteTooltipContent": "_71VIVG_NoteTooltipContent",
  "NoteTooltipTrigger": "_71VIVG_NoteTooltipTrigger",
  "NoteTooltipWrapper": "_71VIVG_NoteTooltipWrapper",
  "PriceQtyWrapper": "_71VIVG_PriceQtyWrapper",
  "PriceWrap": "_71VIVG_PriceWrap",
  "QtyControl": "_71VIVG_QtyControl",
  "QtyValue": "_71VIVG_QtyValue",
  "SoldOut": "_71VIVG_SoldOut",
  "Spacer": "_71VIVG_Spacer",
  "TicketNotice": "_71VIVG_TicketNotice",
  "Tier": "_71VIVG_Tier",
  "TierDescription": "_71VIVG_TierDescription",
  "TierWrapper": "_71VIVG_TierWrapper",
  "Uppercase": "_71VIVG_Uppercase",
});
